/**
 * app状态
 */
enum AppState {
    已安装 = 0,
    已启用 = 1,
    已禁用 = 3,
    已禁止 = 4,
    已卸载 = 5, 
}

export default AppState;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/AppState/index.ts